import React from "react";
import { ReactComponent as CartIcon } from "../../assets/icons/header/while-cart.svg";
import { ReactComponent as CartBlackIcon } from "../../assets/icons/header/cart.svg";
import { useCustomNavigate } from "core/hooks/useCustomNavigate";
import { route, RouterName } from "core/router";
import { useDispatch, useSelector } from "react-redux";
import { resetSearchRecipe } from "modules/Recipes/store/actions";

interface CartBadgeProps {
  type?: string;
  className?: string;
}

const CartBadge = ({type, className}: CartBadgeProps) => {
  const navigate = useCustomNavigate();
  const dispatch = useDispatch();
  const { countCart } = useSelector((state: any) => state.Carts || {});
  const handleShowCart = () => {
    dispatch(resetSearchRecipe()); // RESTORE SEARCH RECIPE
    navigate(route(RouterName.CARTS));
  };

  return (
    <button
      className={`relative ${className} ${type === 'main' ? 'px-4' : ''}`}
      data-testid="cart-badge"
      onClick={handleShowCart}
    >
      {
        type === 'main' ? <CartIcon /> : <CartBlackIcon/>
      }
      
      {Number(countCart) !== 0 && <span className={`absolute 
        text-[11px] 
        top-[-7px] 
        right-[5px] 
        bg-[#FF6741] 
        text-white 
        rounded-full 
        flex 
        items-center 
        justify-center
        w-[16px] h-[16px]
        ${type !== 'main' ? '!top-[-2px] !right-[-4px]' : ''}
        ${Number(countCart) > 99 ? ' text-[9px] tracking-tighter' : ''}       
        `}>
        {Number(countCart) > 99 ? '99+' : countCart}
      </span> }
    </button>
  );
};

export default CartBadge;
